/*
 * Tarjeta de resumen de una sección (etiqueta, valor grande y ayuda). tone: 'neutral' | 'up' (verde,
 * algo bueno) | 'down' (salmón, algo a revisar). El color nunca va solo: la etiqueta dice qué es.
 * Las tarjetas KPI con minigráfica y comparación del dashboard son otro componente (etapa 4).
 */
import React from "react";

const StatTile = ({label, value, hint, tone = 'neutral'}) => (
    <div className={`mc-tile mc-tile--${tone}`}>
        <span className="mc-tile__label">{label}</span>
        <strong className="mc-tile__value mc-num">{value}</strong>
        {hint && <span className="mc-tile__hint">{hint}</span>}
    </div>
);

export default StatTile;
